import { ref, watch } from 'vue';
import ApiService from '@/core/services/api.service';

export default function useLocationHierarchy(options = {}) {
  const { form } = options;

  const cities = ref([]);
  const districts = ref([]);
  const wards = ref([]);

  const isLoadingCities = ref(false);
  const isLoadingDistricts = ref(false);
  const isLoadingWards = ref(false);

  const loadCities = async () => {
    if (cities.value.length > 0) return;

    try {
      isLoadingCities.value = true;
      const { data } = await ApiService.get('city/');
      cities.value = data.data || [];
      isLoadingCities.value = false;
    } catch (error) {
      console.error('Failed to load cities:', error);
      isLoadingCities.value = false;
    }
  };

  const loadDistricts = async (cityId, resetSelection = false) => {
    if (!cityId) {
      districts.value = [];
      wards.value = [];
      return;
    }

    if (resetSelection && form) {
      form.district = null;
      form.ward = null;
    }

    try {
      isLoadingDistricts.value = true;
      const { data } = await ApiService.get(`city/${cityId}/district`);
      districts.value = data.data || [];
      isLoadingDistricts.value = false;
    } catch (error) {
      console.error('Failed to load districts:', error);
      isLoadingDistricts.value = false;
    }
  };

  const loadWards = async (districtId, resetSelection = false) => {
    if (!districtId) {
      wards.value = [];
      return;
    }

    if (resetSelection && form) {
      form.ward = null;
    }

    try {
      isLoadingWards.value = true;
      const { data } = await ApiService.get(`city/${districtId}/ward`);
      wards.value = data.data || [];
      isLoadingWards.value = false;
    } catch (error) {
      console.error('Failed to load wards:', error);
      isLoadingWards.value = false;
    }
  };

  if (form) {
    watch(
      () => form.city,
      (newCityId) => {
        if (newCityId) {
          loadDistricts(newCityId, true);
        } else {
          districts.value = [];
          wards.value = [];
        }
      },
    );

    watch(
      () => form.district,
      (newDistrictId) => {
        if (newDistrictId) {
          loadWards(newDistrictId, true);
        } else {
          wards.value = [];
        }
      },
    );
  }

  loadCities();

  return {
    cities,
    districts,
    wards,
    loadCities,
    loadDistricts,
    loadWards,
    isLoadingCities,
    isLoadingDistricts,
    isLoadingWards,
  };
}
